import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import {PreloaderService} from "../../common/services/preloader/preloader.service";
import {catchError, map, tap} from "rxjs/operators";
import {Observable} from "rxjs/Observable";
import Delivery from '../../models/Delivery';
import DeliveryTiming from "../../models/DeliveryTiming";

@Injectable()
export class DeliveryService extends ServiceProvider {

  protected url = '/api/v1/delivery';

  constructor(
  ) {
    super(
      AppInjector.get(HttpClient),
      AppInjector.get(ApiUrl),
      'Delivery'
    );
  }

  downloadDeliveries(deliveryIds: any = ''): Observable<any> {
    let query = [];
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/export/' + deliveryIds, {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result =>
        result
      ),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  bulkUpdate(data: any = []): Observable<any> {
    let query = [];
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/bulk', data).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result =>
        new Delivery(result)
      ),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  bulkCreate(data: any = []): Observable<any> {
    let query = [];
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/bulk', data).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result =>
        new Delivery(result)
      ),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  getDeliveryTimings(params = {}): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.get(this.apiUrl.getApiUrl(`${this.url}/timings`)).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => _.map((result as any).data, item => new DeliveryTiming(item))),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  remindDriverOnHisWay(params): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(`${this.url}/${params.id}/remind/driver-on-his-way`), {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }
}
